<template>
  <div>
    <div class="question-overlay question-overlay--left">
      <img :src="`${assetPath}lockup-overlays/quiz_04-overlay--left@2x.png`" alt="">
    </div>
    <div class="question-overlay question-overlay--top">
      <img :src="`${assetPath}lockup-overlays/quiz_04-overlay--top@2x.png`" alt="">
    </div>
    <div class="accessible-text">
      <p>Our Employees Drink Coffee Because...</p>
    </div>
    <transition name="fade">
      <div :class="{ 'transitioned-in': initialized }">
        <div class="svg-wrapper">
          <CoffeeBecause class="coffee-because" />
        </div>
        <div class="svg-wrapper">
          <CoffeeBecauseMobile class="coffee-because--mobile" />
        </div>
        <form class="buttons">
          <template v-for="(question, index) in questions">
            <div :key="index">
              <input type="radio" :id="question.id" name="drinkFor" :value="question.value" @click="formInteraction(question.value)" :checked="question.value === drinkFor">
              <label :for="question.id"><span v-html="question.label"></span></label>
            </div>
          </template>
        </form>
      </div>
    </transition>
    <div class="question-overlay question-overlay--right">
      <img :src="`${assetPath}lockup-overlays/quiz_04-overlay--right@2x.png`" alt="">
    </div>
    <div class="question-overlay question-overlay--bottom">
      <img :src="`${assetPath}lockup-overlays/quiz_04-overlay--bottom@2x.png`" alt="">
    </div>
  </div>
</template>

<script>
import { next } from './../../mixins/next.js'
import { assetPath } from './../../mixins/assetPath.js'
import CoffeeBecause from '@/assets/coffee-because.svg'
import CoffeeBecauseMobile from '@/assets/coffee-because--mobile.svg'

export default {
  name: 'QCoffeeBecause',
  components: {
    CoffeeBecause,
    CoffeeBecauseMobile
  },
  props: {
    initialized: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      drinkFor: this.$store.state.quiz.drinkFor,
      questions: [
        {
          id: 'caffeine',
          value: 'caffeine',
          label: 'They Need Caffeine'
        },
        {
          id: 'taste',
          value: 'taste',
          label: 'They Love the Taste'
        },
        {
          id: 'ritual',
          value: 'ritual',
          label: 'It&rsquo;s a Cherished Ritual'
        }
      ]
    }
  },
  methods: {
    formInteraction(value) {
      this.drinkFor = value
      this.next('drinkFor', this.drinkFor)
    }
  },
  mixins: [next, assetPath]
}
</script>

<style lang="scss">

.coffee-because {
  display: none;
  @include breakpoint(large) {
    display: block;
  }
}
.coffee-because--mobile {
  display: block;
  @include breakpoint(large) {
    display: none;
  }
}

.question--question-four {
  // background-image: url($q4bgMobile);
  background-size: cover;
  width: 100%;
  .svg-wrapper {
    width: 89.333%;
    position: relative;
    top: -13vw;
  }
  .question-overlay--left {
    width: 53.854%;
  }
  .question-overlay--right {
    width: 28.333%;
  }
  .question-overlay--top {
    top: -4vw;
  }
  @include breakpoint(large) {
    .svg-wrapper {
      width: 65.1%;
      top: 0;
      svg {
        height: 29vw; // for IE
      }
    }
    // background-image: url($q4bgDesktop);
  }
  .buttons {
    left: 0;
    right: 0;
    bottom: 19%;
    width: 89.333%;
    margin: 0 auto;
    display: block; // kill flex
    div {
      width: 100%;
      margin-bottom: -3px;
    }
    label {
      padding: 0.333em 1.5em;
    }
    @include breakpoint(large) {
      bottom: 14%; // proto
      width: 65%;
      padding-right: 1%;
      display: flex; // restore
      label {
        padding: 0.5em 1.5em;
      }
      div {
        width: 33.333%;
        margin-right: -3px;
      }
    }
  }
}

</style>